import { Button } from '@bambi/component-library/src/components/Button/Button';
import { PencilIcon } from '@heroicons/react/24/outline';

import { useModal } from 'src/common/modals/useModal';

import { PricingWizardModal } from '../AddPricingSchemeButton';
import { ClonePricingSchemeButton } from './ClonePricingSchemeButton';
import { PricingSchemeDeleteButton } from './PricingSchemeDeleteButton';

export function RowActions({ pricingSchemeId }: { pricingSchemeId: string }) {
  const { open, setOpen, openModal } = useModal();
  return (
    <div className="flex flex-row items-center justify-end">
      <Button
        dataTestId="pricing-management-edit-button"
        onClick={openModal}
        variant="icon"
      >
        <div
          className="flex flex-col items-center text-xs"
          style={{ fontSize: '0.625rem' }}
        >
          <PencilIcon className="h-5 w-5 cursor-pointer hover:text-mint" />
          Edit
        </div>
      </Button>
      <ClonePricingSchemeButton pricingSchemeId={pricingSchemeId} />
      <PricingSchemeDeleteButton pricingSchemeId={pricingSchemeId} />
      <PricingWizardModal
        open={open}
        setOpen={setOpen}
        pricingSchemeId={pricingSchemeId}
        mode="edit"
      />
    </div>
  );
}
